import React from "react";
import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import PDFTEMPLATEContent from "./PDFTEMPLATEContent";

interface StudentData {
  student_name: string;
  admission_no: string;
  class_name: string;
  academic_year: string;
  term: string;
  total_score: number;
  remark: string;
  result: string;
}

interface Group {
  student: StudentData;
  scores: StudentData[];
}

interface MergedPDFTemplateProps {
  groups: Group[];
  school: any;
  grading: any[];
}

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
});

const MergedPDFTemplate: React.FC<MergedPDFTemplateProps> = ({ groups, school, grading }) => {
  return (
    <Document>
      {groups.map((group, index) => (
        <Page key={index} size="A3" style={styles.page}>
          <PDFTEMPLATEContent
            student={group.student}
            scores={group.scores}
            school={school}
            grading={grading}
          />
        </Page>
      ))}
    </Document>
  );
};

export default MergedPDFTemplate;
